import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=4943b788&scoped=true"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"
import style0 from "./detailList.vue?vue&type=style&index=0&id=4943b788&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4943b788",
  null
  
)

export default component.exports